import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'
import logo from '../images/logo-w.png'
import a from '../images/a.jpg'

const Contact = () => {

    return (
        <>
		
         <Wrap style={{ backgroundImage: `url(${a})` }}>
         <Imag>
				<img src={logo} alt="logo" height={300}/>
			</Imag>
           
         <Fade bottom>
				<ItemText>
					
                     
                    <Wrapper>
            <RowWrapper>
            <Heading >CONTACT US :</Heading>
                         <h2>club.csitmjpru@gmail.com</h2>
                         <h2>+91-8534833926</h2>
                         <h2>Harshit Kumar Singh (Student Incharge)</h2>
                         <h2>Department Of CSIT, </h2>
                         <h2>Mahatma Jyotiba Phule Rohilkhand University,</h2>
                         <h2>Bareilly, Uttar Pradesh Pincode:-243006</h2>

                         </RowWrapper>
         </Wrapper>
				</ItemText>
			</Fade>
            
         </Wrap>
        
        </>
    );

}

export default Contact;

const Heading = styled.div`
    font-size : 80px;
    color : green;
`

const Wrap = styled.div `
    min-height:100vh;
    background-color: rgb(28, 29, 54)  ;
	color:white;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: row; /* switch to vertical */
	justify-content: space-evenly; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	@media (max-width : 768px){
		flex-direction: column;
	}
`

const ItemText = styled.div `
	padding-top: 5vh;
	text-align: center;
`
const Imag= styled.div `
display: flex;
flex-direction: row; /* switch to vertical */
justify-content: center; /* horizontal alignment */
align-items: center; /* vertical alignment */
     min-width:10vw;
     height:50vh;
`

const Wrapper = styled.div`
  position: relative;
  color:white;
  
  padding: 1rem;
  background: rgba(15, 14, 71, 0.3);
  box-shadow: 0px 30px 60px rgba(0, 0, 0, 0.25),
    inset 0 0 0 0.5px rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  backdrop-filter: blur(3px);
  margin: 0 auto;
`;

const RowWrapper = styled.div`
  width: 100%;
  display: flex;
	flex-direction: column; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */
`;